
import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_CORE_IO, {
  transports: ["websocket"],
  withCredentials: true,
  reconnection: true,
});

socket.on("connect", () => console.log("✅ Connected to socket:", socket.id));
socket.on("hello", (msg) => console.log("📨 Server says:", msg));
socket.on("disconnect", () => console.log("❌ Socket disconnected"));